// extracted by mini-css-extract-plugin
export default {"input":"Input_input__vzEhA","correct":"Input_correct__vHUup","error":"Input_error__wXsEQ"};